
import _ from 'underscore';

import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { ISetCertificationAction } from '../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { setCertificationAction } from '../actions/labels/SetCertificationAction';
import { selectCatalogingOnSiteEnabled } from '../selectors/CatalogSelectors';

export const SetCertificationEntityAction: IEntityAction<IContentInfo<'datasource'> | IContentInfo<'virtualConnection'> | IContentInfo<'virtualConnectionTable'> | IContentInfo<'view'>, ISetCertificationAction> = {
  name: EntityActionNames.SetCertification,
  translateName: Messages.editCertification,
  isVisible: (items, state) => _.first(items).contentType === 'view' ? FeatureFlags.viewCertificationEnabled : true,
  isClickable: (availableActions: ISetCertificationAction) => !!(availableActions && availableActions.setCertification),
  createReduxAction: (items) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error(Messages.setCertificationError());
    }

    return setCertificationAction(items[0]);
  }
};

/**
 * TODO: at some point we should determine if we need this other action,
 * if cataloging isn't enabled then you can't get to the list view or the place page for db/tb
 * and therefore this isVisible is probably not really that useful
 */
export const SetCertificationDatabaseAndTableAction: IEntityAction<IContentInfo<'database'> | IContentInfo<'table'>, ISetCertificationAction> = {
    name: EntityActionNames.SetCertification,
    translateName: Messages.editCertification,
    isVisible: (items, state) => selectCatalogingOnSiteEnabled(state),
    isClickable: (availableActions: ISetCertificationAction) => !!(availableActions && availableActions.setCertification),
    createReduxAction: (items) => {
      if (!items || items.length === 0 || items.length > 1) {
        throw new Error(Messages.setCertificationError());
      }

      return setCertificationAction(items[0]);
    }
  };
